const DocsBookIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="2" width="16" height="18" rx="1.5" fill="#b6dbc5" stroke="#007a4a" strokeWidth="1.5" />
    <line x1="6.5" y1="2" x2="6.5" y2="20" stroke="#007a4a" strokeWidth="1.2" />
    <path d="M5 20.5H19.5" stroke="#007a4a" strokeWidth="0.8" strokeLinecap="round" />
    <path d="M5.5 21.5H19" stroke="#007a4a" strokeWidth="0.6" strokeLinecap="round" />
    <path d="M16 2V6L17.2 5L18.4 6V2" fill="#007a4a" opacity="0.4" />
    <text
      x="12.75"
      y="17"
      textAnchor="middle"
      fontFamily="'Hoefler Text', Georgia, 'Times New Roman', serif"
      fontWeight="bold"
      fontStyle="italic"
      fontSize="16"
      fill="#007a4a"
    >
      i
    </text>
  </svg>
);

export default DocsBookIcon;
